import { Text, View, StyleSheet, Image, Font } from "@react-pdf/renderer";
import React from "react";

const FourQuadrantImg = require("../../../Assets/Images/Four-Quadrant.png");
const LatoRegular = require("../../../Assets/Fonts/Lato-Font/Lato-Regular.ttf");
const LatoBold = require("../../../Assets/Fonts/Lato-Font/Lato-Bold.ttf");

Font.register({
  family: "Lato",
  fonts: [
    { src: LatoRegular, fontWeight: 400 },
    { src: LatoBold, fontWeight: 700 },
  ],
});

const styles = StyleSheet.create({
  coverSection: {
    borderRadius: "5px",
    textAlign: "center",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    fontFamily: "Lato",
    backgroundColor: "#ffffff",
    padding: "20px",
  },
  coverTitle: {
    marginBottom: "20px",
    fontSize: "18px",
    fontWeight: 700,
    color: "#426b88",
    fontFamily: "Lato",
    textAlign: "left",
  },
  contentContainer: {
    marginTop: "5px",
    textAlign: "left",
    maxWidth: "800px",
  },
  highlightText: {
    fontWeight: "700",
    fontSize: "12px",
    lineHeight: "18px",
    fontFamily: "Lato",
  },
  paragraph: {
    fontWeight: "400",
    fontSize: "12px",
    lineHeight: "18px",
    color: "#245775",
    textAlign: "justify",
    marginBottom: "10px",
    marginTop: "5px",
    flexShrink: 1,
  },
  paragraphSection: {
    fontFamily: "Lato",
    fontWeight: "400",
    fontSize: "12px",
    lineHeight: "18px",
    color: "#245775",
    textAlign: "justify",
    marginBottom: "10px",
  },
  coverImage: {
    width: "80%",
    maxWidth: "300px",
  },
  sectionRow: {
    display: "flex",
    flexDirection: "row",
    alignItems: "flex-start",
    justifyContent: "space-between",
    width: "100%",
    maxWidth: "800px",
  },
  textSection: {
    flex: 1,
    paddingLeft: "20px",
  },
  textContainer: {
    flex: 1,
    paddingLeft: "1px",
    maxWidth: "75%",
  },
});

const FourQuadrantPage = () => {
  return (
    <View style={styles.coverSection}>
      <View style={styles.sectionRow}>
        <View>
          <Image src={FourQuadrantImg} style={styles.coverImage} />
        </View>
        <View>
          <View style={styles.textContainer}>
            <Text style={styles.coverTitle}>THE FOUR QUADRANTS</Text>
            <Text style={styles.paragraph}>
              <Text style={[styles.highlightText, { color: "#D9534F" }]}>
                Heart:
              </Text>{" "}
              This quadrant describes the emotive center of our being—that part
              of us that feels, values, wills, and connects with others. We
              discover who we are, what we want, and who we want to relate to
              from this inner space. From this dimension, we build social
              constructs, find our tribe, and build a life with and for others.
              It answers the core question of Who. Collaborative Leadership is
              the style associated with Heart. 
            </Text>
          </View>
        </View>
      </View>

      {/* Content Section */}
      <View style={styles.contentContainer}>
        <Text style={styles.paragraph}>
          <Text style={[styles.highlightText, { color: "#00577D" }]}>
            Soul:
          </Text>{" "}
          This is the meaning center of our being—the part of us that seeks to
          make sense of our lives, our stories, and our purpose in the world.
          From this space, we dream, imagine, and create. We cast a vision for
          our lives, families, and business enterprises and then inspire
          ourselves and others toward that desired future. This quadrant answers
          the core question of Why. Visionary Leadership is the style associated
          with Soul.
        </Text>

        <Text style={styles.paragraph}>
          <Text style={[styles.highlightText, { color: "#245775" }]}>
            Mind:
          </Text>{" "}
          This dimension describes the strategic center of our being—that part
          of us that organizes and structures our inner and outer worlds into
          intelligible systems. From this space, we seek to understand reality
          and sort it into logical connections that make sense and provide
          coherence and safety for ourselves and others. From the mind, we build
          and attach ourselves to theories and truths that provide a container
          to hold our way of being in the world. This quadrant answers the core
          question of What. Strategic Leadership is the style associated with
          Mind. 
        </Text>

        <Text style={styles.paragraph}>
          <Text style={[styles.highlightText, { color: "#F39C12" }]}>
            Strength:
          </Text>
          This quadrant describes the sensory center of our being—that part of
          us that allows us to absorb the tactile data around us and convert
          that information into action. We experience and engage the physical
          world from this space, gathering resources and adopting behaviors for
          accomplishing goals. This quadrant is anchored in our bodies and, as
          such, is distinct from the other three internal dimensions of self. It
          answers the core question of How. Performance Leadership is the style
          associated with Strength.
        </Text>
      </View>
    </View>
  );
};

export default FourQuadrantPage;
